import {
  InfiniteSearchHook,
  useInfiniteSearchSelect,
} from '../form/input/usePagedAutocomplete';
import { OptionType } from '../queryClient';
import { Select, SelectProps } from './Select';

export interface InfiniteSearchSelectProps<
  ValueType = any,
  T extends OptionType = OptionType,
  FetchOptions = any,
> extends Omit<SelectProps<ValueType>, 'pages'> {
  searchOptions?: FetchOptions;
  useSearchHook: InfiniteSearchHook<T, FetchOptions>;
}

export const InfiniteSearchSelect = <
  ValueType = any,
  T extends OptionType = OptionType,
  FetchOptions = any,
>(
  props: InfiniteSearchSelectProps<ValueType, T, FetchOptions>,
) => {
  const {
    loading,
    searchOptions,
    onClear,
    onFocus,
    onSearch,
    useSearchHook,
    ...rest
  } = props;
  const { data, selectProps } = useInfiniteSearchSelect({
    useSearchHook,
    searchOptions: searchOptions,
    onClear,
    onFocus,
    onSearch,
  });

  const isLoading = Boolean(loading || selectProps.loading);

  return (
    <Select
      {...rest}
      {...selectProps}
      loading={isLoading}
      pages={data?.pages}
    />
  );
};
